import DefinitionTooltip from '../DefinitionTooltip';
import { GoogleIcon, InstagramIcon, TikTokIcon } from '../Icons';
import TopHashtagsSection from './TopHashtagsSection';
import TopInstagramHashtagsSection from './TopInstagramHashtagsSection';
import TopKeywordsSection from './TopKeywordsSection';
import { tooltips } from '@/copy';

const Wrapper = (props) => <div {...props} />;

const createTermsDrawerSection = ({
    Icon,
    Section,
    heading,
    tooltip,
    contentKey,
    tooltipWidth,
    dated = false,
}) => {
    function Heading({ children, showIcon, data }) {
        return (
            <div className="my-6 flex flex-wrap text-base font-semibold">
                <span css="display: flex; align-items: center; gap: .5rem;">
                    {showIcon ? <Icon /> : null}
                    {heading}
                    <DefinitionTooltip
                        {...tooltip}
                        {...(dated && { week: data?.week, year: data?.year })}
                        mixpanelMeta={{ contentKey }}
                        openOnClick={true}
                        {...(tooltipWidth && { width: tooltipWidth })}
                    />
                </span>
                {children}
            </div>
        );
    }

    return (props) => (
        <Section
            HeadingComponent={Heading}
            WrapperComponent={Wrapper}
            {...props}
        />
    );
};

export const TopHashtagsDrawerSection = createTermsDrawerSection({
    Icon: TikTokIcon,
    Section: TopHashtagsSection,
    heading: 'Hashtags',
    tooltip: tooltips.hashtags,
    contentKey: 'hashtags',
    dated: true,
});

export const TopInstagramHashtagsDrawerSection = createTermsDrawerSection({
    Icon: InstagramIcon,
    Section: TopInstagramHashtagsSection,
    heading: 'Hashtags',
    tooltip: tooltips.hashtagsInstagram,
    contentKey: 'hashtagsInstagram',
    dated: true,
});

export const TopKeywordsDrawerSection = createTermsDrawerSection({
    Icon: GoogleIcon,
    Section: TopKeywordsSection,
    heading: 'Search Queries',
    tooltip: tooltips.searchQueries,
    contentKey: 'searchQueries',
    tooltipWidth: '25rem',
});
